import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

export default function Support() {
  return (
    <div className="min-h-screen bg-[#FFFBF7] text-[#5F5650]">
      <Navbar />
      <main className="px-4 py-12 md:px-8">
        <article className="mx-auto w-full max-w-[800px] rounded-2xl bg-white p-6 shadow-sm md:p-10">
          <h1 className="font-[Nunito] text-4xl font-extrabold text-[#5B3FA6]">PottyPal Support</h1>
          <p className="mt-2 text-sm text-[#7B716A]">We&apos;re here to help parents get the most out of PottyPal.</p>

          <section className="mt-8 space-y-6 leading-relaxed">
            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">Contact us</h2>
              <p className="mt-2">
                Email:{' '}
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>
              </p>
              <p className="mt-2">Typical response time: within 2 business days.</p>
              <p className="mt-2">
                Include your account email, device type (iPhone / Android), and a short description of the issue so we can
                help faster.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">Common help topics</h2>
              <ul className="mt-2 list-disc space-y-2 pl-6">
                <li>
                  <strong>Account &amp; sign-in:</strong> email/password, Google, or Sign in with Apple (iOS).
                </li>
                <li>
                  <strong>Reminders &amp; notifications:</strong> enable notifications in iPhone Settings → PottyPal, then
                  check reminder settings inside the app.
                </li>
                <li>
                  <strong>Subscriptions:</strong> manage or cancel Premium / Pro Family in your Apple ID subscriptions
                  (Settings → Apple ID → Subscriptions) or Google Play subscriptions.
                </li>
                <li>
                  <strong>Data &amp; privacy:</strong> export or delete your account anytime in Settings → Data &amp;
                  Privacy.
                </li>
                <li>
                  <strong>Co-parent / caregiver invites:</strong> share the invite link from Settings; the invitee must use
                  the same email the invite was sent to.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">Feature requests &amp; feedback</h2>
              <p className="mt-2">
                Send ideas or feedback to{' '}
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>
                , or use Share Feedback inside the app.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">Legal</h2>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>
                  <a className="text-[#5B3FA6] underline" href="/privacy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a className="text-[#5B3FA6] underline" href="/terms">
                    Terms of Service
                  </a>
                </li>
              </ul>
              <p className="mt-4 text-sm text-[#7B716A]">
                PottyPal provides general potty training guidance only and is not medical advice. Always consult your
                pediatrician for medical concerns.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">Company</h2>
              <p className="mt-2">LogicalFlows</p>
              <p>
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>
              </p>
            </div>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  );
}
